module.exports = __webpack_public_path__ + "img/gb-whatsapp-pc-logo.21197b3b.png";